/**
 * @module experience/billing-landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const MANAGE_AUTOPAY_CONSTANTS = {
  PAST_DATE: 'pastDate',
  MAX_DATE: 'maxDate',
  AUTOPAY: 'autoPay',
  AUTOREFILL: 'AutoRefill',
  coverMyChargesEnum: 'autoRefill',
  monthlyEnum: 'Monthly',
  twiceAMonthEnum: 'SemiMonthly',
  every2WeeksEnum: 'BiWeekly',
  weeklyEnum: 'Weekly',
  monthlyPlanType: 'monthly',
  DAYS: '28',
  WEB: 'web',
  paymentDayOneSelection: 'one',
  paymentDayTwoSelection: 'two',
  RETAIL: 'retail',
  DATE_FORMAT: 'MM/dd/yyyy',
  REFILL_ACCOUNT: '/refill-account',
  MY_PROFILE: '/my-profile',
  TRUE: 'true',
  UPDATE: 'Update',
  ADD: 'Add',
  POST: 'Post',
  DELETE: 'Delete',
  REMOVE: 'Remove',
  MANUAL: 'Manual',
  STRING: 'string',
  TEMPORARY_TOKEN: 'TemporaryToken',
  PERMANENT_TOKEN: 'PermanentToken',
  ERROR_MESSAGES: 'errorMessages',
  APPROVAL: 'approval',
  BUTTON_ID: 'button1',
  BUTTON_TYPE: 'submit',
  BUTTON_CLASS: 'btn btn-primary',
  AUTOPAYCONFIRMATION: '/autopay/confirmation',
  AUTOPAYREVIEW: '/autopay/review',
  OPTION: 'Option',
  STARTDATE: 'startDate',
  DUE_DATE_FORMAT: 'YYYY-MM-DDThh:mm:ssTZD',
  TIMEZONE: 'America/Los_Angeles',
  NEXT_PAYMENT_DATE_FORMAT: 'MM/DD/YYYY',
  LEGAL_TEXT: 'legal-text',
  DATE_FORMAT_YYYYMMDD: 'YYYY-MM-DD',
  DEFAULT_TIME: 'T00:00:00.000Z',
  DEFAULT_TIME_NO_ZONE: 'T00:00:00.000',
  DEBIT: 'Debit',
  CREDIT: 'Credit',
  CC: 'CC',
  HD: 'HD',
  autoPayEnum: 'AutoPay',
  autoRefillEnum: 'AutoRefill',
  ANON: 'ANON',
  DUMMYTOKEN: 'DUMMYDPSTOKEN',
};

export const NO_OF_PAYMENT_ENUM = {
  AutoPay: 1,
  autoRefill: 1,
  Monthly: 1,
  SemiMonthly: 2,
  BiWeekly: 2,
  Weekly: 4,
  radixParameter: 10,
  two: 2,
  four: 4,
  date: 31,
};

export const AUTOPAY_ROUTE = '/autopay';
